export default __webpack_public_path__ + "static/encuentra_la_pareja-56e25f71a5aef4c61050ebe3c95d126d.png";